// import { API_CONFIG } from './apiConfig.js';
import { getApiEndpoint } from './apiConfig.js';
import { API_CONFIG, REACT_APP_API_URL } from '../config';

// Use the API URL from config.js to ensure consistency
export const API_BASE_URL = REACT_APP_API_URL;

// Log API configuration
console.log('API Configuration:');
console.log('Environment:', process.env.NODE_ENV === 'development' ? 'Development' : 'Production');
console.log('API Base URL:', API_BASE_URL);
console.log('API URL:', `${API_BASE_URL}/api/v1/e-prorab`);

/**
 * Get the full API URL for a specific endpoint
 * @param {string} endpoint - The API endpoint (without leading slash)
 * @returns {string} - The full API URL
 */
export const getApiUrl = (endpoint) => {
  // Make sure endpoint doesn't start with a slash
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  return `${API_BASE_URL}/api/v1/e-prorab/${cleanEndpoint}`;
};

/**
 * Get a complete URL for an image
 * @param {string} imagePath - The image path or URL
 * @returns {string} - The complete image URL
 */
export const getImageUrl = (imagePath) => {
  console.log('getImageUrl input:', imagePath);
  
  // If it's already a complete URL, return it
  if (!imagePath) {
    return '';
  }
  
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's a relative path starting with 'uploads/', create a direct URL to the uploads folder
  if (imagePath.startsWith('uploads/')) {
    const directUploadsUrl = `${API_BASE_URL}/${imagePath}`;
    console.log('Created direct uploads URL:', directUploadsUrl);
    return directUploadsUrl;
  }
  
  // Otherwise, create a full API URL
  return `${API_BASE_URL}/api/v1/e-prorab/${imagePath}`;
};

/**
 * Check if the provided URL is a valid API URL
 * @param {string} url - The URL to check
 * @returns {boolean} - True if the URL is valid
 */
export const isValidApiUrl = (url) => {
  try {
    // Parse the URL to check its components
    const parsed = new URL(url);
    
    // Check if it's a valid API endpoint
    return parsed.pathname.includes('/api/v1/e-prorab/');
  } catch (error) {
    return false;
  }
};

const apiUtils = {
  API_BASE_URL,
  getApiUrl,
  isValidApiUrl,
  getImageUrl
};

export default apiUtils; 